const getActiveBrandPromotion = (brandName, brandPromotions)=>{
    if (!brandPromotions) {
        return undefined;
    }
    return brandPromotions.find(({ name  })=>name.toLowerCase() === brandName.toLowerCase()
    );
};

export { getActiveBrandPromotion };
//# sourceMappingURL=get-active-brand-promotion.js.map
